const { HttpStatusCode } = require('@/constants/index')
const salt = process.env.X_WEB_SECRET || process.env.VUE_APP_X_WEB_SECRET
const channel = process.env.X_WEB_CHANNEL || process.env.VUE_APP_X_WEB_CHANNEL
module.exports = {
  salt,
  channel,
  baseURL: '/',
  /** 默认超时时间10分钟 */
  requestTimeout: 1000 * 60 * 10,
  /** 默认 application/json */
  contentType: 'application/json;charset=UTF-8',
  /** 接口成功返回的code码 */
  successCodes: [HttpStatusCode.SUCCESS, HttpStatusCode.CACHE_SUCCESS],
  /** 忽略接口错误提示的code码（含总部券失效码，由业务页 catch 后自行弹窗并刷总部券） */
  ignoreCodes: [4006030, 4007010, 4006218, 4006050, 4007012, 4007016, 4007021, 4007022, 4006145, 4006149],
  /** 需要重新登录的code码 */
  loginBackInCodes: [4011021, 4011155, 4011160],
  /** 缓存数据白名单 */
  cacheWhiteList: [],
  /** 全局 loading 文本 */
  loadingText: '加急处理中',
  /** 需要语音播报的接口列表 */
  speechApiLists: ['/mg/daohang-order-api/recheckOrder/skuScan'],
  /** 忽略检查更新接口的白名单 */
  ignoreCheckUpdateWhiteList: ['/mg/drp-admin-api/portal/page', '/mg/daohang-basic-api/componentFile/requestSTSToken'],
}
